exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".leftRigthMargin10{padding-left:40px;padding-right:40px}@media (min-width:768px){.list-inline-unstyled-XS{padding-left:0;list-style:none;margin-left:-5px}.list-inline-unstyled-XS>li{display:inline-block;padding-left:15px;padding-right:15px}}@media (max-width:768px){.list-inline-unstyled-XS{padding-left:0;list-style:none}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/client/styles/responsive_ul.css
 ** module id = 59
 ** module chunks = 0
 **/